
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexX7XD_45vQPq8XNiIWzYDgQqTxmGYGzQW9lDdGh66pelK0Meta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/index.vue?macro=true";
import { default as rulesjR5_45O6uPJmDlV76HWszqpp9n_45jltxjZsBqLJdP_45wd_wMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/rules.vue?macro=true";
import { default as stamphORfR_0X7vW5E7w8ZIYbPQvKmoxW5mND9LWWkdLfwB8Meta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/stamp.vue?macro=true";
import { default as member3kvEse12jqngVCkjj2L_45KRsuQ2C5BtfFnqzMnmZmWKQMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/member.vue?macro=true";
import { default as versionpBoi_NV_45OQBJKnVeZmStZufx72ryRs4mlQK24e6_45eb0Meta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/version.vue?macro=true";
import { default as winnersoOQha1DYV4QDeBLsSzPDOSIS_45RVZeCz9LMYvCH9TUQ8Meta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/winners.vue?macro=true";
import { default as rankingsSDVerIDIz_45F07Xyo1CX0l4IPdO7K8HS5yxp9WYNV8ScMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/rankings.vue?macro=true";
import { default as _91id_93IF8r3nA51deusPLLZjSXzXqygN9124FN7SGBCfE_45ECoMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/trails/[id].vue?macro=true";
import { default as indexoV8B9fNqO_IaicsDBWOX5sjpwQW_zR8TIehsFOx3C0EMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/trails/index.vue?macro=true";
import { default as indexg1txMbVvnsteGGga2VXJHUJTCq0XuY9uLnRS3QvATskMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/challenge/index.vue?macro=true";
import { default as _91zone_93S1EpAyeClGNAX1NKI0v3Xnon4HnTyo1CjO8KjDezi50Meta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/challenge/[zone].vue?macro=true";
import { default as _91platform_937pexT3n8AaMeEdvHPvqZgaS0zJDuLMwQY1QEX9OGQKsMeta } from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/auth/callback/[platform].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexX7XD_45vQPq8XNiIWzYDgQqTxmGYGzQW9lDdGh66pelK0Meta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/index.vue")
  },
  {
    name: "rules",
    path: "/rules",
    meta: rulesjR5_45O6uPJmDlV76HWszqpp9n_45jltxjZsBqLJdP_45wd_wMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/rules.vue")
  },
  {
    name: "stamp",
    path: "/stamp",
    meta: stamphORfR_0X7vW5E7w8ZIYbPQvKmoxW5mND9LWWkdLfwB8Meta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/stamp.vue")
  },
  {
    name: "member",
    path: "/member",
    meta: { ...(member3kvEse12jqngVCkjj2L_45KRsuQ2C5BtfFnqzMnmZmWKQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/member.vue")
  },
  {
    name: "version",
    path: "/version",
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/version.vue")
  },
  {
    name: "winners",
    path: "/winners",
    meta: winnersoOQha1DYV4QDeBLsSzPDOSIS_45RVZeCz9LMYvCH9TUQ8Meta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/winners.vue")
  },
  {
    name: "rankings",
    path: "/rankings",
    meta: rankingsSDVerIDIz_45F07Xyo1CX0l4IPdO7K8HS5yxp9WYNV8ScMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/rankings.vue")
  },
  {
    name: "trails-id",
    path: "/trails/:id()",
    meta: _91id_93IF8r3nA51deusPLLZjSXzXqygN9124FN7SGBCfE_45ECoMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/trails/[id].vue")
  },
  {
    name: "trails",
    path: "/trails",
    meta: indexoV8B9fNqO_IaicsDBWOX5sjpwQW_zR8TIehsFOx3C0EMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/trails/index.vue")
  },
  {
    name: "challenge",
    path: "/challenge",
    meta: indexg1txMbVvnsteGGga2VXJHUJTCq0XuY9uLnRS3QvATskMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/challenge/index.vue")
  },
  {
    name: "challenge-zone",
    path: "/challenge/:zone()",
    meta: { ...(_91zone_93S1EpAyeClGNAX1NKI0v3Xnon4HnTyo1CjO8KjDezi50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/challenge/[zone].vue")
  },
  {
    name: "auth-callback-platform",
    path: "/auth/callback/:platform()",
    meta: _91platform_937pexT3n8AaMeEdvHPvqZgaS0zJDuLMwQY1QEX9OGQKsMeta || {},
    component: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/pages/auth/callback/[platform].vue")
  }
]